import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import GenericButton from '../../common/GenericButton';
import GenericStudyDisplay from '../../common/GenericStudyDisplay';
import GenericSearch from '../../common/GenericSearch';
import TrendListItems from './TrendListItems';
import * as studyActions from '../../../actions/studyActions';
import { getStudiesAsList } from '../../../util/CommonUtils';
import * as CrosstabUtils from '../../../util/CrosstabUtils';
import { IPSOS_DISABLED_STUDY_LIST } from '../../../actions/urlTypes';
import { 
  MRI_SAC_STUDY_TYPE_ID, 
  MRI_SAC_DOUBLEBASE_STUDY_TYPE_ID, 
  MRI_USA_STUDY_TYPE_ID
} from '../../../constants';
import { getTrendStudiesData } from '../../../actions/crosstabActions';

class TrendMultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      itemsLeft: [],
      itemsRight: [],
      selectedItemsLeft: [],
      selectedItemsRight: [],
      rightSelectionCount: 0,
      crosstabStudy: props.crosstabStudy,
      items: [],
    };
    this.getTrendStudies()
  }

  UNSAFE_componentWillMount() {
    const itemsRight = [];
    const itemsLeft = [];
    let updateFlag = false;

    this.state.itemsLeft.map(item => {
      if (
        this.props.trendStudies.find(
          trend => item.pn === trend.pn,
        )
      ) {
        itemsRight.push(item);
        updateFlag = true;
      } else {
        itemsLeft.push(item);
      }
      return item;
    });
    if (updateFlag) {
      this.setState({ itemsRight, itemsLeft });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.crosstabStudy !== nextProps.crosstabStudy) {
      this.setState({ crosstabStudy: nextProps.crosstabStudy });
    }
    if (
      this.props.studies !== nextProps.studies &&
      nextProps.studies
    ) {
      const items = getStudiesAsList(nextProps.studies)
        .filter(
          study =>
            !(
              this.props.crosstabStudy &&
              this.props.crosstabStudy.pn === study.pn
            ),
        )
        .map((study, index) => ({
          id: index,
          productNo: study.pn,
          text: study.sd,
          selected: false,
        }));

      this.setState({
        searchText: '',
        itemsLeft: items,
        itemsRight: [],
        selectedItemsLeft: [],
        selectedItemsRight: [],
        rightSelectionCount: 0,
        items,
      });
    }
  }

  getTrendStudies = async () => {
    let filterStudiesOnWeightTypes = [];
    const data = await getTrendStudiesData(
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      this.props.crosstabStudy.pn,
      this.props.crosstabWeightTypes.wt
    );
    const filteredStudies = data.filter(item => item.cn !== 'BASE_STUDY');
    filteredStudies.forEach(item => {
      const formattedStudyList = item.sl.map((study, index) => {
        return {
          id: filterStudiesOnWeightTypes.length + index,
          productNo: study.pn,
          text: study.sd,
          selected: false,
        }
      })
      filterStudiesOnWeightTypes = [...filterStudiesOnWeightTypes, ...formattedStudyList];
    })
    this.setState({
      searchText: '',
      itemsLeft: filterStudiesOnWeightTypes,
      itemsRight: [],
      selectedItemsLeft: [],
      selectedItemsRight: [],
      rightSelectionCount: 0,
      crosstabStudy: this.props.crosstabStudy,
      items: filterStudiesOnWeightTypes,
    });
  }

  getTrendType() {
    const studyList = _.cloneDeep(this.props.studies);
    if (this.props.crosstabStudy && this.props.crosstabStudy.sti) {
      const studyGroup = CrosstabUtils.getStudyGroup(this.props.crosstabStudy.sti, studyList);
      return studyGroup;
    }
    return undefined;
  }

  handleOK = () =>
    this.props.studyActions.setTrendStudies(
      this.state.itemsRight.map(study => ({
        pn: study.productNo,
        sd: study.text,
      })),
    );

  handleSearch = searchResult => this.setState({ itemsLeft: searchResult });

  handleLeftPanelClick = (id, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = this.state.selectedItemsLeft;
      }
      selectedItems.push(parseInt(id, 10));
      this.setState({
        selectedItemsLeft: selectedItems,
      });
    } else {
      selectedItems = this.state.selectedItemsLeft;
      let lastItem = this.state.selectedItemsLeft.pop();
      let currentItemId = id;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      this.state.itemsLeft.map(item => {
        if (item.id >= lastItem && item.id <= parseInt(currentItemId, 10)) {
          selectedItems.push(item.id);
        }
        return item;
      });
      this.setState({
        selectedItemsLeft: selectedItems,
      });
    }
  };

  handleRightPanelClick = (id, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = this.state.selectedItemsRight;
      }
      selectedItems.push(parseInt(id, 10));
      this.setState({
        selectedItemsRight: selectedItems,
      });
    } else {
      selectedItems = this.state.selectedItemsRight;
      let lastItem = this.state.selectedItemsRight.pop();
      let currentItemId = id;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      this.state.itemsRight.map(item => {
        if (item.id >= lastItem && item.id <= parseInt(currentItemId, 10)) {
          selectedItems.push(item.id);
        }
        return item;
      });
      this.setState({
        selectedItemsRight: selectedItems,
      });
    }
  };

  addSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    this.state.itemsLeft.map(item => {
      if (item.selected) {
        selections.push(item);
      } else {
        itemsRemaining.push(item);
      }
      return item;
    });

    this.state.itemsRight.map(item => {
      selections.push(item);
      return item;
    });
    this.setState({
      itemsLeft: itemsRemaining,
      itemsRight: this.sort(selections),
      rightSelectionCount: selections.length,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    });
  };

  removeSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    this.state.itemsRight.map(item => {
      if (item.selected) {
        selections.push(item);
      } else {
        itemsRemaining.push(item);
      }
      return item;
    });

    this.state.itemsLeft.map(item => {
      selections.push(item);
      return item;
    });
    this.setState({
      itemsLeft: this.sort(selections),
      itemsRight: itemsRemaining,
      rightSelectionCount: itemsRemaining.length,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    });
  };

  removeAll = () => {
    const leftPanelItems = [];
    leftPanelItems.push(...this.state.itemsLeft, ...this.state.itemsRight);
    this.setState({
      itemsRight: [],
      itemsLeft: this.sort(leftPanelItems),
      rightSelectionCount: 0,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    });
  };

  sort = array => {
    array.sort((item1, item2) => {
      if (item1.id < item2.id) {
        return -1;
      }
      if (item1.id > item2.id) {
        return 1;
      }
      return 0;
    });
    return array;
  };

  render() {
    return (
      <div className="trend-multiselect-modal-body">
        <div>
          <div className="width-left columns">
            <div className="trend-search-component">
              <GenericSearch
                searchItems={this.state.items}
                searchField="text"
                handleSearchResult={this.handleSearch}
              />
            </div>
            <TrendListItems
              items={this.sort(this.state.itemsLeft)}
              selectedItems={this.state.selectedItemsLeft}
              handleSelection={this.handleLeftPanelClick}
            />
          </div>
          <div className="width-center columns">
            <div className="stacked button-group multi-select-button-group">
              <GenericButton
                name=" "
                btnStyle="button btn-add btn-priaryDisable"
                onBtnClick={this.addSelected}
                {...(this.state.selectedItemsLeft.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />
              <GenericButton
                name=" "
                btnStyle="button btn-remove btn-cncl"
                onBtnClick={this.removeSelected}
                {...(this.state.selectedItemsRight.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />
              {/*              <GenericButton
                name="&lt;&lt; Remove All"
                btnStyle="button btn-cncl"
                onBtnClick={this.removeAll}
                {...this.state.selectedItemsRight.length < 1 ? { btnDisabled: true } : {}}
/> */}
            </div>
          </div>
          <div className="width-right columns multi-select-list-right">
            <div className="base-study-display-holder">
              {this.state.crosstabStudy ? (
                <div>
                  <label className="base-study-text" htmlFor="base-study">
                    Base Study:{' '}
                  </label>
                  <GenericStudyDisplay
                    studyClass="base-study-display-text"
                    weightClass="base-study-display-text"
                    studyDescription={this.state.crosstabStudy.sd}
                    weightType={this.state.crosstabStudy.wt}
                    customWeights={this.state.crosstabStudy.cw}
                    crosstabWeightTypes={this.props.crosstabWeightTypes}
                  />
                </div>
              ) : (
                ''
              )}
              <div>
                <label className="base-study-text" htmlFor="trend-study">
                  Trend Studies:{' '}
                  <span className="study-number-circle">
                    {this.state.itemsRight.length}
                  </span>
                </label>
              </div>
            </div>
            <TrendListItems
              items={this.sort(this.state.itemsRight)}
              selectedItems={this.state.selectedItemsRight}
              handleSelection={this.handleRightPanelClick}
            />

            <div className="modal-footer no-padding trend-multi-button">
              <div className="large-12 margin-top-15 float-right">
                <GenericButton
                  name="Clear All"
                  btnStyle="button btn-clear-all-trend-items float-left"
                  onBtnClick={() => {
                    this.removeAll();
                  }}
                  {...(this.state.selectedItemsRight.length < 1
                    ? { btnDisabled: true }
                    : {})}
                />
                <GenericButton
                  btnStyle="button run-trend"
                  name="Run Trend"
                  {...(this.state.itemsRight.length &&
                  (this.props.columnsDataGrid.length ||
                    this.props.rowsDataGrid.length)
                    ? {}
                    : { btnDisabled: true })}
                  {...(this.state.itemsRight.length > 0 &&
                  (this.props.columnsDataGrid.length ||
                    this.props.rowsDataGrid.length)
                    ? {}
                    : { title: 'please select atleast one row or column' })}
                  onBtnClick={() => {
                    this.props.setChartType();
                    this.handleOK();
                    this.props.handleParentHide();
                    this.props.runCrosstab('Trend');
                  }}
                />
                <div className="clear clearfix" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TrendMultiSelect.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
    }),
  }),
  handleParentHide: PropTypes.func,
  crosstabStudy: PropTypes.shape({
    pn: PropTypes.number,
    tf: PropTypes.number,
    sti: PropTypes.number,
  }),
  studies: PropTypes.arrayOf(PropTypes.object),
  studyActions: PropTypes.shape({
    setTrendStudies: PropTypes.func,
  }),
  trendStudies: PropTypes.arrayOf(PropTypes.object),
  setChartType: PropTypes.func,
  runCrosstab: PropTypes.func,
  columnsDataGrid: PropTypes.arrayOf(PropTypes.object),
  rowsDataGrid: PropTypes.arrayOf(PropTypes.object),
  crosstabWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
    wn: PropTypes.number,
  }),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    crosstabStudy: state.study.crosstabStudy,
    studies: state.study.studies,
    trendStudies: state.study.trendStudies,
    crosstabWeightTypes: state.study.crosstabWeightTypes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    studyActions: bindActionCreators(studyActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(TrendMultiSelect);
